
    import '/opt/buildhome/repo/components/useXChat/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["components-use-x-chat-demo-basic","components-use-x-chat-demo-stream","components-use-x-chat-demo-suggestions"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/useXChat/index.zh-CN.md?type=demo')
};